import React from 'react';
import styled from '@emotion/styled';
import { Product } from '../types';

interface BicycleCardProps {
  product: Product;
}

const CardContainer = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  margin: 24px 0;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
`;

const ProductImage = styled.img`
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: block;
`;

const PlaceholderImage = styled.div`
  width: 100%;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
  font-size: 64px;
  border-radius: 12px;
`;

const BicycleCard: React.FC<BicycleCardProps> = ({ product }) => {
  const [imageError, setImageError] = React.useState(false);

  return (
    <CardContainer>
      {!imageError ? (
        <ProductImage 
          src={product.product.productImage} 
          alt={product.product.productName}
          onError={() => setImageError(true)}
        />
      ) : (
        <PlaceholderImage>🚲</PlaceholderImage>
      )}
    </CardContainer>
  );
};

export default BicycleCard;
